import {Component, OnInit} from '@angular/core';

import {Role} from '../../models/Role.enum';
import {UserHelper} from '../../utils/UserHelper';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html'
})

export class AppHeaderComponent implements OnInit {
  Roles: typeof Role = Role;
  public disabled: boolean = false;
  public status: { isOpen: boolean } = {isOpen: false};
  public username: string = '';

  constructor(private userHelper: UserHelper) {
  }

  ngOnInit(): void {
    const user = this.userHelper.getUser();
    this.username = `${user.firstname} ${user.lastname}`;
    this.userHelper.userChanged.subscribe(user => {
      this.username = `${user.firstname} ${user.lastname}`;
    });
  }

  public toggled(open: boolean): void {
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isOpen = !this.status.isOpen;
  }

  public resize() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 400);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/layouts/header/header.component.ts